import { getPackageTrips } from './getPackageTrips';
export const formatTripMessageContent = trip => {
  if (!trip) return '';
  const contents = ['Need help with this'];
  if (trip.type === 'PACKAGE') {
    const pkgTrip = getPackageTrips(trip);
    contents.push(`${pkgTrip.pkgType || 'package'} reservation.`);
    if (pkgTrip.title) {
      contents.push(`In ${pkgTrip.title}`);
    }
    if (pkgTrip.dateHeader) {
      contents.push(`during ${pkgTrip.dateHeader}.`);
    }
  } else {
    if (trip.type === 'DRIVE') {
      contents.push('car reservation.');
    }
    if (trip.type === 'FLY') {
      contents.push('flight reservation.');
    }
    if (trip.type === 'STAY') {
      contents.push('hotel reservation.');
    }
    if (trip.title) {
      contents.push(`In ${trip.title}`);
    }
    if (trip.dateHeader) {
      contents.push(`during ${trip.dateHeader}.`);
    }
  }
  return contents.join(' ');
};